export const blockIconsActionDelete = (
	<span className='material-symbols-outlined'>delete</span>
);
